// extracted by mini-css-extract-plugin
export default {"section":"StatsBar_section__qIHgW","statItem":"StatsBar_statItem__ZHEFE","value":"StatsBar_value__9zDaQ","label":"StatsBar_label__KKn2U","divider":"StatsBar_divider__4mDDF"};